import React, { useEffect, useState } from 'react';
import { Button, LoadingIndicator, FLink, Icons } from '@components';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { mdiCommentAlertOutline } from '@mdi/js';
import { Link } from '@mui/material';
import { EmprestimoService } from '../../../common/services/emprestimo';
import {
  CALENDARIO_EMPRESTIMO,
  EMPRESTIMOS,
  REGULAMENTO_EMPRESTIMO,
} from '../../../common/utils/paths';

export const RegrasGeraisEmprestimoPage = () => {
  const navigate = useNavigate();
  const [dadosRegraGerais, setDadosRegrasGerais] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const service = new EmprestimoService();

    service
      .obterRegrasGerais()
      .then((res) => {
        setDadosRegrasGerais(res);
      })
      .finally(() => setLoading(false));
  }, []);

  return loading ? (
    <LoadingIndicator />
  ) : (
    <>
      <Helmet>
        <title>Forluz - Regras Gerais do Empréstimo</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Regras Gerais do Empréstimo</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-block d-lg-flex align-items-center">
            <Icons
              path={mdiCommentAlertOutline}
              color="var(--primary-color)"
              size={2}
              style={{ marginRight: 4 }}
            />
            <p className="fw-bold ts-18 mb-2">
              Evite que seu formulário seja devolvido. Leia o Regulamento do
              Empréstimo e fique atento às mudanças.
            </p>
          </div>
          <hr className="my-3 " />
          <div className="ts-16 text-muted">
            <p className="mt-2">
              Os limites individuais foram atualizados em{' '}
              {dadosRegraGerais.DataLimiteIndividual} e são válidos somente para
              os pedidos que chegarem de {dadosRegraGerais.DataLimiteInicial} a{' '}
              {dadosRegraGerais.DataLimiteFinal}. Para visualizar os limites e
              gerar o formulário, você deve clicar no subitem{' '}
              <Link href={EMPRESTIMOS}>Simular e Contratar</Link>. e depois em{' '}
              <span className="primary-color">
                &quot;Li os Termos e Aceito&quot;
              </span>
              .
            </p>
            <p className="mt-3">
              Leia com atenção todas as cláusulas do contrato e o Regulamento do
              Empréstimo Forluz antes de fazer sua solicitação.{' '}
              <b>
                Não assuma nenhum compromisso sem confirmar antecipadamente a
                liberação do crédito.
              </b>{' '}
              A confirmação ocorre em até 1 dia útil antes da data do crédito.
            </p>
            <p className="mt-3">
              Acompanhe as datas de pedidos, crédito e cancelamentos no{' '}
              <Link href={CALENDARIO_EMPRESTIMO}>Calendário de Empréstimo</Link>
              . Os cancelamentos deverão ser solicitados através do{' '}
              <Link href="https://forluz.neoassist.com/?th=tag_vforluzfixa&openEmail=true&mainCategory=emprestimo&subCategory=521044">
                Fale Conosco
              </Link>{' '}
              disponível no Portal Forluz ou no 0800-0909090.
              <p className="mt-3">
                Em caso de refinanciamento e havendo desconto da parcela do mês
                referente ao contrato anterior, o valor recebido será antecipado
                no novo contrato.
              </p>
            </p>
            <p className="mt-3">
              Para quitar ou regularizar parcelas em aberto, entre em contato
              com a Forluz, no 0800-0909090 ou{' '}
              <Link href="https://forluz.neoassist.com/?th=tag_vforluzfixa&openEmail=true&mainCategory=emprestimo&subCategory=pagamentos&subCategory2=521056">
                Fale Conosco
              </Link>{' '}
              disponível no portal Forluz.
            </p>
            <p className="mt-3">
              As quitações no mês de {dadosRegraGerais.MesVigente} podem ser
              efetuadas até o dia {dadosRegraGerais.DataLimiteQuitacao}.
            </p>
            <p className="mt-3">
              O índice IPCA utilizado para cálculo das prestações de{' '}
              {dadosRegraGerais.DataPrestacao} foi de {dadosRegraGerais.IPCA}{' '}
              (ref. {dadosRegraGerais.DataReferenciaIPCA}).
            </p>
            <p className="mt-3 fw-bold">
              As informações desta página poderão ser alteradas até o final do
              dia.
            </p>
          </div>

          <FLink className="mt-3 ts-16" to={REGULAMENTO_EMPRESTIMO}>
            Acesse o regulamento clicando aqui
          </FLink>
        </div>
      </div>
    </>
  );
};
